import { render, staticRenderFns } from "./Duty.vue?vue&type=template&id=a2fe5168&scoped=true"
import script from "./Duty.vue?vue&type=script&lang=js"
export * from "./Duty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2fe5168",
  null
  
)

export default component.exports